export const authTokenHeader: string = "authentication"
export const defaultSignedInUrl = "/category"
export const supplementMaterialsCategoryId = "5"

